import {createSlice} from '@reduxjs/toolkit'

const initialState = { 
    isLoading:false,
    live_event:"",
    loadedEvent: false,
    loadingEvent: false,
    loadingContent: "Loading Please Wait",
    duplicateEvent: null,
    error:"" 
}

const liveEventSlice = createSlice({
    name:"live-event",
    initialState,
    reducers:{
        liveEventLoading:(state) => {
            state.isLoading = true
        },
        liveEventItemList:(state, {payload}) => {
            state.live_event = payload
            state.isLoading = false
        },
        liveEventError:(state, {payload}) => {
            state.error = payload
        },
        setLoadedEvent: (state, {payload}) => {
            state.loadedEvent = payload
        },
        setLoadingEvent: (state, {payload}) => {
            state.loadingEvent = payload
        },
        setLoadingContent: (state, {payload}) => {
            state.loadingContent = payload
        },
        setDuplicateEvent: (state, {payload}) => {
            state.duplicateEvent = payload
        }
    }
})

export const { 
    liveEventLoading,
    liveEventItemList,
    liveEventError,
    setLoadedEvent,
    setLoadingEvent,
    setLoadingContent,
    setDuplicateEvent
} = liveEventSlice.actions
export default liveEventSlice.reducer